/** Chemin d'accueil selon le rôle (retour depuis pages publiques connecté). */
export function getRoleHomePath(role) {
  switch (role) {
    case 'superadmin':
      return '/dashboard';
    case 'admin':
      return '/admin/dashboard';
    case 'intervenant':
      return '/intervenant';
    case 'client':
      return '/client';
    default:
      return '/';
  }
}

export function getRoleSettingsPath(role) {
  switch (role) {
    case 'superadmin':
      return '/dashboard/paramètres';
    case 'admin':
      return '/admin/parametres';
    case 'intervenant':
      return '/intervenant/parametres';
    case 'client':
      return '/client/profil';
    default:
      return '/';
  }
}
